import React from "react";
import Modal from 'react-responsive-modal';
import database from '../firebase/firebase'
import {NotificationContainer} from 'react-notifications';
import {connect} from 'react-redux';
import { loadStudentProfile } from "../actions/_student_actions";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

class CompanyModal extends React.Component{

    state = {
        companyName: '',
        locationName: '',
        data: '',
        webSite: '',
        companyAbout:''
    }

    componentDidMount(){
        database.collection('companies').doc(this.props.id).get().then((info) => {
            let data = info.data()
            this.setState({
                companyName: data.companyName,
                locationName: data.locationName,
                data: data.data,
                companyWebsite: data.companyWebsite === "" ? "" : data.companyWebsite,
                companyAbout: data.companyAbout,
                companyLogo: data.companyLogo,
                
            })
        }).catch(e => {
            console.log(e)
        })
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.props.close} 
             closeOnOverlayClick={false} >
                <div className="modal-company">
                    <p className="mc-name">Conoce más de esta empresa</p>
                    <div className="">
                    <img src={this.state.companyLogo} className="mc-img" alt="company-detail"/>
                    <p className="mc-name">Sitio web:</p>
                    {this.state.companyWebsite === "" ? <p className="mc-text">No disponible</p> :
                    <a className="mc-link" href={`https://${this.state.companyWebsite}`} rel="noopener noreferrer" target="_blank">
                        Entrar al sitio
                    </a>}
                    <p className="mc-name">Nombre de la empresa:</p>
                    <p className="mc-text">{this.state.companyName}</p>
                    <p className="mc-name">Ubicación:</p>
                    <p className="mc-text">{this.state.locationName}</p>
                    <p className="mc-name">Descripción:</p>
                    <p className="mc-text">{this.state.companyAbout}</p>
                    <p className="mc-name">Acerca de...</p>
                    <ReactQuill
                        className="description"
                        value={this.state.data}
                        readOnly={true}
                        theme={"bubble"}
                    />
                </div>
                </div>
                <NotificationContainer />
            </Modal>
        );
    }
}
const mapStateToProps = (state) => ({
    uid: state.auth.uid,
    data: state.student.profile
});

const mapDispatchToProps = (dispatch) => ({
    update: (id) => dispatch(loadStudentProfile(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModal);
